<div cdkTrapFocus aria-live="assertive" class="mfa-modal">
  <div class="modal-header border-0 pb-0">
    <button
      type="button"
      class="close ms-auto"
      aria-label="Close MFA Modal"
      ngbAutoFocus
      (click)="close()"
      (keydown.enter)="close()"
      (keydown.space)="close()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="logo-container mb-3">
      <img
        [src]="logoUrl"
        [ngClass]="{
          scion_logo: themeService.isScionEnv
        }"
        alt="Company logo"
        class="mfa-logo"
      />
    </div>

    <h3 class="modal-title mb-2" i18n="@@mfaCodeTitle" id="modal-header">Verify Your Identity</h3>

    <p class="text-muted mb-2" i18n="@@mfaCodeInstructions">
      We've sent an email with your code to
    </p>

    <div class="email-pill mb-4">
      {{ maskedEmail }}
    </div>

    <div class="mfa-input-container text-start">
      <label for="mfa-code-input" class="form-label" i18n="@@mfaCodeLabel">Enter the code*</label>
      <input
        type="text"
        id="mfa-code-input"
        class="form-control"
        [class.is-invalid]="error"
        [attr.maxlength]="codeLength"
        [value]="mfaCode"
        (input)="onCodeInput($event)"
        (keydown.enter)="submitCode()"
        autocomplete="one-time-code"
        inputmode="numeric"
        pattern="[0-9]*"
        aria-required="true"
        [attr.aria-invalid]="error ? 'true' : 'false'"
        [attr.aria-describedby]="error ? 'mfa-error' : resendMessage ? 'mfa-message' : null"
      />
    </div>

    @if (error) {
      <div id="mfa-error" class="alert alert-danger mt-3 text-start" role="alert">
        <span i18n="@@mfaError">Error</span>: {{ error }}
      </div>
    }

    @if (resendMessage) {
      <div id="mfa-message" class="alert alert-info mt-3 text-start" role="status">
        {{ resendMessage }}
      </div>
    }

    <button
      type="button"
      id="button_submit_mfa"
      class="small-button w-100 mt-4"
      aria-label="Submit verification code"
      [attr.aria-busy]="loading"
      (click)="submitCode()"
      (keydown.enter)="submitCode()"
      (keydown.space)="submitCode()"
      [disabled]="loading || mfaCode?.length !== codeLength"
      i18n="@@mfaCodeSubmit"
    >
      @if (!loading) {
        <span>Continue</span>
      }
      @if (loading) {
        <span>Verifying...</span>
      }
    </button>

    <div class="resend-container mt-3">
      <span i18n="@@mfaCodeNotReceived">Didn't receive an email?</span>
      <button
        type="button"
        class="btn btn-link p-0 ms-1"
        [attr.aria-busy]="resending"
        aria-label="Resend verification code"
        [disabled]="resendDisabled || resending"
        (click)="resendCode()"
        (keydown.enter)="resendCode()"
        (keydown.space)="resendCode()"
      >
        @if (resending) {
          <span>Sending...</span>
        }
        @if (!resending && resendCountdown > 0) {
          <span i18n="@@mfaCodeResendCountdown">Resend in {{ resendCountdown }}s</span>
        }
        @if (!resending && resendCountdown <= 0) {
          <span i18n="@@mfaCodeResend">Resend</span>
        }
      </button>
    </div>
  </div>
</div>
